/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalReprogramarTurno.css';
import redirectTo from '../../../utils/redirectTo';
import * as telemedicinaActions from '../../../actions/telemedicinaActions';

class ModalReprogramarTurno extends React.Component {
  componentDidMount() {}
  render() {
    return (
      <div>
        <div className="modal fade" id="ModalReprogramarTurno">
          <div className="modal-dialog">
            <div className={`${s.modalContent} modal-content`}>
              <div className="modal-header">
                <h5 className="modal-title">Reprogramar turno</h5>
              </div>
              <div className={`${s.modalBody} modal-body`}>
                <div>
                  Lo sentimos, en este momento no podemos atenderte. Por favor
                  agendá un nuevo turno.
                </div>
              </div>
              <div className={`${s.modalFooter} modal-footer`}>
                <button
                  data-dismiss="modal"
                  className={`${s.boton_rojo} btn btn-danger text-center`}
                  onClick={() => {
                    this.props.hideValidacionesTecnicas();
                    redirectTo('/telemedicina/solicitud-turnos');
                  }}
                >
                  Agendar nuevo turno
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, telemedicinaActions)(
  withStyles(s)(ModalReprogramarTurno),
);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalReprogramarTurno/ModalReprogramarTurno.js